module.exports = __webpack_public_path__ + "img/DE02576.6eab9804.png";